export default __webpack_public_path__ + "static/media/EllipseLeft.c174e2b4.png";